export const INITIAL_STATE = {
    categoryName: '',
    displayOrder: '',
    status: '',
    bannerImage1Large: '',
    bannerImage2Medium: '',
    bannerImage3Small: '',
    displayTitle: '',
    subTitle: '',
    loading: false,
    error: '',
    success: false,
    fieldErrors: {},
};

export const SUCCESS_MESSAGE = 'PRODUCT_CATEGORY_ADDED_SUCCESSFULLY';

export const TOAST_MESSAGES = {
    success: 'Product category created successfully!',
    error: 'Failed to create product category. Please try again.',
    updateSuccess: 'Product category updated successfully!',
    updateError: 'Failed to update product category. Please try again.',
};

export const VALIDATION_ERROR_MESSAGES = {
    categoryName: 'Please provide a category name.',
    displayOrder: 'Display order is required and must be a number.',
    status: 'Status is required.',
    bannerImage1Large: 'Banner Image 1 (Large) URL is required.',
    bannerImage2Medium: 'Banner Image 2 (Medium) URL is required.',
    bannerImage3Small: 'Banner Image 3 (Small) URL is required.',
};

export const PRODUCT_CATEGORY_FORM_FIELDS = [
    {
        name: 'categoryName',
        label: 'Category Name',
        type: 'text',
        placeholder: 'Enter category name',
        required: true,
        validationMessage: 'Please provide a category name.',
    },
    {
        name: 'displayOrder',
        label: 'Display Order',
        type: 'number',
        placeholder: 'Enter Order',
        required: true,
        validationMessage: 'Display order is required and must be a number.',
    },
    {
        name: 'status',
        label: 'Status',
        type: 'select',
        required: true,
        validationMessage: 'Status is required.',
    },
    {
        name: 'bannerImage1Large',
        label: 'Banner Image 1 (Large)',
        type: 'text',
        placeholder: 'Enter large banner image url',
        required: true,
        validationMessage: 'Banner Image 1 (Large) URL is required.',
    },
    {
        name: 'bannerImage2Medium',
        label: 'Banner Image 2 (Medium)',
        type: 'text',
        placeholder: 'Enter medium banner image url',
        required: false,
        validationMessage: '',
    },
    {
        name: 'bannerImage3Small',
        label: 'Banner Image 3 (Small)',
        type: 'text',
        placeholder: 'Enter small banner image url',
        required: false,
        validationMessage: '',
    },
    {
        name: 'displayTitle',
        label: 'Display Title',
        type: 'text',
        placeholder: 'Enter title to display',
        required: false,
        validationMessage: '',
    },
    {
        name: 'subTitle',
        label: 'Sub Title',
        type: 'text',
        placeholder: 'Enter sub title to display',
        required: false,
        validationMessage: '',
    },
];

export const STATUS_OPTIONS = [
    { label: 'Published', value: 'PUBLISHED' },
    { label: 'Unpublished', value: 'UNPUBLISHED' },
];

// Validate form data and return an errors object keyed by field name
export const validateForm = (formData = {}) => {
    const errs = {};

    // Validate only required fields
    PRODUCT_CATEGORY_FORM_FIELDS.forEach(field => {
        if (field.required) {
            const val = formData[field.name];
            const empty = val === null || typeof val === 'undefined' || String(val).trim() === '';

            if (empty) {
                errs[field.name] = field.validationMessage || `${field.label} is required`;
            }
        }
    });

    return errs;
};
